import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import createForm from "./Form";
import TemplateEditor from "../../form/editor/TemplateEditor";
import MjmlField from "../../form/mjml/MjmlField";

class EmailTemplateForm extends React.Component {

    render() {
        return (
            <form onSubmit={ this.props.handleSubmit }>
                {this.props.fieldForm === undefined ? <Fragment>
                    <div className="row form-row">
                        <div className="col-sm-1 col-sm-push-11">
                            <TextInput
                                name={this.props.componentConfig.idfield}
                                value={this.props.values[this.props.componentConfig.idfield]}
                                label="Kód"
                                role="idfield"
                            />
                        </div>
                        <div className="col-sm-5 col-sm-push-5">
                            <TextInput
                                name="token"
                                value={this.props.values.token}
                                label="Token"
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                        <div className="col-sm-6 col-sm-pull-6">
                            <TextInput
                                name="subject"
                                value={this.props.values.subject}
                                label="Tárgy"
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-sm-2">
                            <Select
                                objectValue={false}
                                name="type"
                                optionname="emailtype"
                                storeType="local"
                                value={this.props.values.type}
                                label="Típus"
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                        <div className="col-sm-2">
                            {this.props.values.type === "fix" && <TextInput
                                name="subtype"
                                value={this.props.values.subtype}
                                label="Fix típus"
                                saveChanges={this.props.setFieldValue}
                            />}
                        </div>
                    </div>
                </Fragment> : <Fragment>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="form-group">
                                <TextInput
                                    name="subject"
                                    value={this.props.values.subject}
                                    label="Tárgy"
                                    saveChanges={this.props.setFieldValue}
                                />
                            </div>
                        </div>
                    </div>
                </Fragment>}
                <div className="row form-row">
                    <div className="col-md-12">
                        {
                            this.props.values.template_engine !== "mjml"
                            ?
                            <TemplateEditor
                                {...this.props.getFieldProps("template")}
                                name="template"
                                component={this.props.componentConfig.componentname}
                                componentId={this.props.values[this.props.componentConfig.idfield]}
                                value={this.props.values.template}
                                label="Tartalom"
                                height="400px"
                                saveChanges={this.props.setFieldValue}
                            />
                            :
                            <MjmlField
                                {...this.props.getFieldProps("template")}
                                name="template"
                                label="Tartalom"
                                component={this.props.componentConfig.componentname}
                                componentId={this.props.values[this.props.componentConfig.idfield]}
                                saveChanges={this.props.setFieldValue}
                                value={this.props.values.template}
                                disabled="disabled"
                            />
                        }
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(EmailTemplateForm);
